<template>
    <path :style="{ fill: color }" d="M32.3,41.6c-0.1-0.2-0.4-1.4-0.5-3.5c0-1,0.2-2.5,0.1-3.6c-0.3-3.9-3.1-14-0.4-17.4s4.1-2.5,5.1-4.5
	c1-1.9,4-5.9,7.7-7.4c3.7-1.5,6.5-0.3,10.9,0.6s4.4,2.5,6.8,2.1c2.4-0.4,4.5-0.1,7.2,2.4c2.2,2,5.3,4.5,7.1,7.5s-0.2,11.4-0.6,13.7
	c-0.1,0.5-0.4,2-0.5,3.5c-0.1,1.2,0,2.5,0,3.4c-0.1,2-0.4,3-0.4,3c-1.4,0.7-1.8,5.9-2.2,5.8c-0.4-0.1,0-3.5-0.4-6.4
	c-0.3-2.3-1-3.8-1.3-6.2c-0.3-2.4,0.3-8.2-2.6-9.3c-2.9-1.1-6.5,2.1-15.1,2.1c-8.6,0-13.8-3.7-15.9-0.6c-2.1,3.1-1.4,5.2-1.5,8.3
	c-0.1,3.1-1.3,4.6-1.4,6.3c-0.1,1.9-0.2,5.2-0.5,5.2C33.8,46.8,33.1,42.2,32.3,41.6z"/>
</template>

<script>
    import Hair from './Hair';

    export default {
        name: 'Hair6',
        mixins: [Hair],
    }
</script>

